import { render, staticRenderFns } from "./PiuInformazioniStruttura.vue?vue&type=template&id=12191192&scoped=true&"
import script from "./PiuInformazioniStruttura.vue?vue&type=script&lang=js&"
export * from "./PiuInformazioniStruttura.vue?vue&type=script&lang=js&"
import style0 from "./PiuInformazioniStruttura.vue?vue&type=style&index=0&id=12191192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12191192",
  null
  
)

export default component.exports